import { HOST, VERSION } from "../constants"

const BASE = `${HOST}${VERSION}admin/compras/notificacion`

export const last = `${BASE}/last` /* -> get */
export const list = `${BASE}/list` /* -> post */
export const marcarLeida = `${BASE}/marcar-leida` /* -> post */
export const marcarTodasLeidas = `${BASE}/marcar-todas-leidas` /* -> post */
